import portaro from '../portaro';

portaro.directive('jpCustomParagraph', ['$sce',
    function($sce) {
        return {
            restrict: 'E',
            replace: true,
            template: '<div kp-compiled-content="content"></div>',
            scope: {
                content: '='
            },
            link: function ($scope) {
                $scope.$sce = $sce;
            }
        };
    }]);